 
import type { PriceFilterValue } from '~~/types/integrations/tagManager/TagClickFilterTypes';
import type { EventSourceLocation } from '~~/types/integrations/tagManager/TagManagerIntegration';

export const buildClickFilterTags = ({
  filterInteraction,
  filterSection,
  filterName,
  filterValue,
  categoryPath,
  categoryName,
  listingType,
}: {
  filterInteraction: string,
  filterSection: string,
  filterName: string,
  filterValue: PriceFilterValue,
  categoryPath: string,
  categoryName: string,
  listingType: EventSourceLocation
}) => ({
  event: filterInteraction,
  event_info: {
    filter_section: filterSection,
    filter_name: filterName,
    filter_value: filterValue,
    category_path: categoryPath,
    category_name: categoryName,
    listing_type: listingType,
  },
});
